import { SELECIONAR_MAPA_VEICULO_ITINERARIO } from '../types'

export default function selecionarMapaVeiculoItinerario (assento, fileira) {
  return {
    type: SELECIONAR_MAPA_VEICULO_ITINERARIO,
    payload:{assento, fileira}
  }
}
